const CLUTCH_URL = 'https://clutch.co/profile/lasoft';
const GOODFIRMS_URL = 'https://www.goodfirms.co/company/lasoft';
const DESIGNRUSH_URL = 'https://www.designrush.com/agency/profile/lasoft';
const TOPDEVELOPERS_URL = 'https://www.topdevelopers.co/profile/lasoft';
const TECHREVIEWERS_URL = 'https://techreviewer.co/companies/lasoft';
const ACIETY_URL = 'https://aciety.com/company/lasoft';

const IMG_URL = `https://img.lasoft.org`;

const IMG = {
  ABOUT: `${IMG_URL}/img/about`,
  ALL_FLAGS: `${IMG_URL}/flags/`,
  QUICK_QUOTE: `${IMG_URL}/quick-quote`,
  SOFTWARE_PROJECT_ESTIMATION: `${IMG_URL}/img/pages/software-project-estimation`,
  TESTIMONIALS: `${IMG_URL}/img/testimonials`,
  LASOFT: `${IMG_URL}/img`,
};

const MENU_BUTTONS = [
  { id: 'features', text: 'Features' },
  { id: 'how-it-works', text: 'How it works' },
  { id: 'faq', text: 'FAQ' },
];

const PHONE_NUMBERS = [
  { id: 'US', phone: '+1 206 681 1521', country: 'USA' },
  { id: 'CH', phone: '+41 076 201 157 1', country: 'Switzerland' },
  { id: 'PL', phone: '+48 422 202 701', country: 'Poland' },
  { id: 'UA', phone: '+38 091 481 07 01', country: 'Ukraine' },
];

const ACHIEVEMENTS = [
  {
    id: 'award-clutch-top-developers-ukraine-2020',
    text: 'Top BTB company on Clutch',
    link: CLUTCH_URL,
  },
  {
    id: 'award-topdevelopers-top-python-developers-2020',
    text: 'Top Web & Python developers company on TopDevelopers.co',
    link: TOPDEVELOPERS_URL,
  },
  {
    id: 'award-topreviewer-top-web-design-for-small-business-2021',
    text: 'Top Web design for Small Business on Techreviewer.co',
    link: TECHREVIEWERS_URL,
  },
  {
    id: 'award-goodfirms-top-web-development-company',
    text: 'Top Web Development Company on Goodfirms',
    link: GOODFIRMS_URL,
  },
  {
    id: 'award-designrush-best-ruby-on-rails-agency',
    text: 'Best Ruby on Rails agency on DesignRush',
    link: DESIGNRUSH_URL,
  },
  {
    id: 'award-system-architecture-development',
    text: 'System Architecture Development',
    link: ACIETY_URL,
  },
];

const FAQ = [
  {
    id: 1,
    title: 'How accurate are the estimates by the LaEstimator AI?',
    text: 'LaEstimator AI delivers estimates with up to 90% accuracy, thanks to an AI engine trained on numerous real-world software projects.',
  },
  {
    id: 2,
    title:
      'Is your software development cost calculator suitable for estimating the cost of e-commerce or complex websites?',
    text: 'LaEstimator AI is trained to handle a variety of projects, including landing pages and complex SaaS or e-commerce platforms.',
  },
  {
    id: 3,
    title:
      'Can the software development cost calculator give me an estimate for an MVP?',
    text: 'You can indicate that you’re planning a Minimum Viable Product, and the tool will generate a lean, priority-based cost estimate focused on essential features for fast market validation.',
  },
  {
    id: 4,
    title:
      'What project details do I need to provide to obtain the most accurate software cost estimate?',
    text: 'To obtain a reliable estimate, please provide a brief description of your product idea, specify the platform type (e.g., web, mobile), outline user roles, identify core features, and indicate your desired delivery timeline.',
  },
  {
    id: 5,
    title:
      'Does the cost calculator cover both front-end and back-end software development costs?',
    text: 'LaEstimator AI considers both front-end (user interface) and back-end (logic, database, API) development work, along with team roles, such as UI/UX designers, QA testers, and DevOps.',
  },
  {
    id: 6,
    title: 'Is my project information kept private?',
    text: "Yes. Any information you share with LaEstimator AI is considered private. Your brief, contact details, and the estimate we generate are used only to prepare your quotation. We don't sell them, or hand them off to any third party. Everything stays inside Lasoft.",
  },
  {
    id: 7,
    title: 'How do you handle the data I submit to the cost calculator?',
    text: "We use it for one thing: to put together your software project estimate. It doesn't go to marketing lists, advertisers, or any other third party. All of it is processed in accordance with the GDPR and the terms set out in our Privacy Policy.",
  },
];

const KEY_FEATURES = [
  {
    id: 1,
    image: 'budget-estimate',
    title: 'AI budget estimate',
    text: "You'll get a total budget figure powered by our AI model",
  },
  {
    id: 2,
    image: 'timeline',
    title: 'Timeline',
    text: 'Project stages and time frames to plan the development process',
  },
  {
    id: 3,
    image: 'team-composition',
    title: 'Team composition',
    text: 'Discover the skill scope you need to develop your product',
  },
  {
    id: 4,
    image: 'project-features',
    title: 'Project features',
    text: 'Get a summary of the insights on potential audience and functionality needed',
  },
];

const HOW_IT_WORKS = [
  {
    id: 1,
    image: 'hiw-01',
    title: 'Enter project details',
  },
  {
    id: 2,
    image: 'hiw-02',
    title: 'Get generated quotes',
  },
  {
    id: 3,
    image: 'hiw-03',
    title: 'Download and share estimates',
  },
  {
    id: 4,
    image: 'hiw-04',
    title: 'Book a free consultation call',
  },
];

const FEATURES_LIST = [
  {
    id: 1,
    title: 'Product overview',
    text: "Gain a summary of your product concept, including functional highlights, potential use cases, and target audience analysis. It's vital to understand the core value your product can deliver.",
    icon: 'ic-clipboard',
  },
  {
    id: 2,
    title: 'Team composition',
    text: 'Receive a detailed breakdown of the roles, expertise, and resources needed to bring your product idea to life. You decide whether to choose an MVP team or a custom software product development.',
    icon: 'ic-users',
  },
  {
    id: 3,
    title: 'Timeline',
    text: 'Understand the stages of development, with estimated time frames for each stage. This information helps you align your roadmap with business goals and launch planning.',
    icon: 'ic-clock',
  },
  {
    id: 4,
    title: 'AI-powered budget estimate',
    text: 'Get a cost estimation generated by our AI model, based on real-world data from similar projects. We offer a cost range depending on the options you choose.',
    icon: 'ic-magic',
  },
  {
    id: 5,
    title: 'Free call to an expert',
    text: 'Contact our expert for a free consultation to explore all your options and receive personalized advice from our professionals.',
    icon: 'ic-message',
  },
];

const SUPPORT = [
  {
    id: 1,
    name: 'LaEstimator',
    pricing: 'Free',
    time: 'Immediate',
    experts: 'Self-service supported by AI.',
    options: {
      accuracy: '60%-70%',
      product_overview: false,
      team_composition: true,
      key_features_list: true,
      schedule_plan: 'High-level',
      budget_plan: 'Ballpark Estimation',
      technology_stack: false,
      system_architecture: false,
      system_informational_architecture: false,
      roadmap: false,
      wireframes: false,
    },
  },
  {
    id: 2,
    name: 'Detailed estimation',
    pricing: '$2,400',
    time: '2 weeks',
    experts:
      'Deep cooperation with a team of experts in Software Development. 4-5 meetings.',
    options: {
      accuracy: '80%-90%',
      product_overview: true,
      team_composition: true,
      key_features_list: true,
      schedule_plan: true,
      budget_plan: true,
      technology_stack: true,
      system_architecture: true,
      system_informational_architecture: true,
      roadmap: true,
      wireframes: true,
    },
    is_contact_form: true,
  },
];

const SUPPORT_LIST_FIELDS = [
  'Accuracy',
  'Product Overview / Vision',
  'Team Composition',
  'Key Features List',
  'Schedule Plan',
  'Budget Plan',
  'Suggested Technology Stack',
  'System Architecture',
  'System Informational Architecture',
  'Product Development Roadmap (3-6 months)',
  'Wireframes for a key system flows',
];

const STAGES = [
  { id: 1, name: 'Basics', mobile_name: 'Basic' },
  { id: 2, name: 'Project stage', mobile_name: 'Stage' },
  { id: 3, name: 'Type of domain', mobile_name: 'Domain' },
  { id: 4, name: 'Project Modules', mobile_name: 'Modules' },
  { id: 5, name: 'Time & budget', mobile_name: 'Time & budget' },
  { id: 6, name: 'Report', mobile_name: 'Report' },
];

const ANIMATED_COUNTERS = [
  {
    id: 1,
    text: 'Business cases discovered',
    start: 0,
    end: 500,
    delay: 0,
    suffix: '+',
  },
  {
    id: 2,
    text: 'Products delivered',
    start: 0,
    end: 85,
    delay: 0,
    suffix: '+',
  },
  {
    id: 3,
    text: 'Years in the market',
    start: 0,
    end: 10,
    delay: 0,
    suffix: '+',
  },
];

const TESTIMONIALS = [
  {
    id: 'Dennis-van-Osch',
    name: 'Dennis van Osch',
    position: 'Director of Operations at Flikweert',
    text: 'Working with the LaSoft team has been a great experience. They were not only highly professional and responsive, but also very friendly and easy to communicate with. Throughout the project, they always kept us updated on the progress. The collaboration was smooth and efficient, and we truly felt that they cared about delivering the best possible result.',
    image: 'Dennis-van-Osch',
  },
  {
    id: 'Kapil-Gupta',
    name: 'Kapil Gupta',
    position: 'CEO, Founder',
    text: 'We’ve been working with LaSoft for almost two years, and it’s been a fantastic experience. They have a strong work ethic, deliver high-quality results, and communicate clearly and responsively. What stands out is their commitment to understanding our needs and going above and beyond to help us. Lasoft has been an amazing partner in building our platform.',
    image: 'Kapil-Gupta',
  },
  {
    id: 'OutSailt',
    name: 'Brett Ungashick',
    position: 'Founder of OutSail',
    text: "The team's work ethic and communication are of the highest quality. LaSoft has created a user-friendly web experience that has resulted in increased customers and more efficient purchases. The team meets the project's deadlines and offers high-quality communication through email and biweekly virtual meetings. LaSoft responds promptly to the client's requests.",
    image: 'Brett-Ungashick',
  },
  {
    id: 'Sh1ft',
    name: 'Samantha Crossman',
    position: 'General Manager at Sh1ft',
    text: 'All of our requests were understood clearly and implemented correctly. Their communication on progress and suggestions was great, and even though these tasks took longer than planned, they kept us constantly updated on progress. It makes our lives so much easier to know we have someone who understands what we need and can translate that clearly to the wider team whilst keeping us regularly updated.',
    image: 'Samantha-Crossman',
  },
  {
    id: 'Blue Manor Academy',
    name: 'Britton LaTulippe',
    position: 'President of Blue Manor Academy',
    text: "In many ways, LaSoft saved our company. Our online academy failed to grow for several years, and we thought it was just our curriculum. We kept improving the curriculum but didn't see an increase in subscriptions. Finally, we hired LaSoft, and they redesigned our checkout system and main dashboard. We immediately saw an increase in subscribers. Now, we have been working with LaSoft for three years and could not be happier!",
    image: 'Britton-LaTulippe',
  },
  {
    id: 'KAMSA',
    name: 'Matt Harbes',
    position: 'CTO of KAMSA',
    text: "We've worked with LaSoft for several years and have always been impressed. Their passion and dedication to Kamsa is second to none, and they are always looking for new ways to improve and ensure the success of our team. We couldn't ask for a better partnership.",
    image: 'Matt-Harbes',
  },
  {
    id: 'Casadesk',
    name: 'Job Breur',
    position: 'Chief Starting Officer',
    text: "LaSoft provided me with a very professional team that delivered good results during the first project. Thanks to this good experience, I had no doubt that I would choose the LaSoft team for a new project. They have all the necessary experience, including UX/UI, programming, testing, project management, and cloud deployment. I enjoy working with guys and trust we've started a long-term relationship.",
    image: 'Job-Breur',
  },
  {
    id: 'Minutes Depot',
    name: 'Louis Bedard',
    position: 'CEO at Minutes Depot',
    text: 'While working on a project, the entire team covers all stages and   needs. We recommend them (LaSoft) without hesitation to anyone looking for high-quality and professional programming for a reasonable price.',
    image: 'Louis-Bedard',
  },
  {
    id: 'Thinking Machine',
    name: 'Jason Docter',
    position: 'Owner of Thinking Machine',
    text: 'LaSoft has an amazing team of highly skilled web designers and programmers. They were able to execute the ideas we had in our head and build a simple website with ease of functionality. They are always available for feedback or quick adjustments. Highly recommended.',
    image: 'Jason-Docter',
  },
  {
    id: 'Britesiders',
    text: 'We have been very impressed with LaSoft’s ability to quickly understand a project and deliver iterations as requested. LaSoft delivered a reliable MVP that is serving as a proof-of-concept. It’s been critical in establishing the client’s business. The project manager was responsive and responsible, making the engagement a pleasurable one. They quickly understood project requirements and showcased their expertise.',
    name: 'Sam Barberie',
    position: 'COO of Britesiders',
    image: 'Sam-Barberie_',
  },
  {
    id: 'EuroNavigator',
    text: 'NGO “Ukrainian Centre for European Policy” started to cooperate with LaSoft almost a year and a half ago and appreciate its team for invaluable support in development of a back-end database and graphical interface for an analytical monitoring product “AA Navigator”. Creative technical and design solutions proposed by LaSoft team were the core inputs into re-launching and upgrading of this analytical tool that is widely used today from the highest governmental level to ordinary citizens who are interested in Ukraine’s European integration for comprehensive monitoring and assessment the progress in implementation of the Association Agreement between the EU and Ukraine.',
    name: 'Liubov Akulenko',
    position: 'Executive director of UCEP',
    image: 'Liubov-Akulenko_',
  },
  {
    id: 'Wristo',
    text: 'This is a young, energetic and yet very experienced team which demonstrated an extremely professional approach.',
    name: 'Matvey Smirnov',
    position: 'Senior R&D Director at PepsiCo',
    image: 'Matvey-Smirnov',
  },
  {
    id: 'Vendorstan',
    text: 'I interviewed many Ukrainian RoR developer companies before I decided to give LaSoft a chance. They had the best combination of price and straight-forward communication style. I loved that they took time to flesh out system requirements before we signed a formal contract. I knew how many releases they recommended, what features would be included in each, who would be on the team and what their hourly rates would be. The team is very hard working and takes pride in their work.',
    name: 'Olga Yurovski',
    position: 'CEO of Shopperations Research & Technology',
    image: 'Olga-Yurovski',
  },
];

const REPORT_OPTIONS = [
  { id: 'fastest', value: 'Fastest & Affordable', cost: '€0–0K' },
  { id: 'balanced', value: 'Balanced Approach', cost: '€0–0K' },
  { id: 'advanced', value: 'Advanced Solution', cost: '€0–0K' },
  { id: 'discovery', value: 'Discovery', cost: '€2,4K' },
  { id: 'design', value: 'UI/UX design', cost: '€3–3,5K' },
];

const REPORT_SERVICES = [
  {
    id: 'digital-product-design',
    title: 'Digital product design',
    text: 'Visualize your product concept and ensure intuitive usability and positive feedback from your target audience.',
    image: 'digital-product-design',
    technologies: ['discovery', 'prototyping', 'visual design', 'figma'],
    link: 'https://lasoft.org/product-design/',
  },
  {
    id: 'software-development-estimation',
    title: 'Software development estimation',
    text: 'Accurate cost and timeframe estimates are key to planning your digital product launch.',
    image: 'software-development-estimation',
    technologies: [
      'efficient Resource Allocation',
      'enhanced Collaboration',
      'effective Risk Management',
    ],
    link: 'https://lasoft.org/software-project-estimation/',
  },
  {
    id: 'product-strategy',
    title: 'Product strategy',
    text: 'System Architecture, Product Design, Marketing, Planning, and Budgeting help you achieve success.',
    image: 'product-strategy',
    technologies: [
      'digital business design',
      'hypothesis definition & testing',
      'product strategy development',
      'MVP Adviser',
    ],
    link: 'https://lasoft.org/product-consulting/',
  },
  {
    id: 'mvp-development',
    title: 'MVP development',
    text: 'Test your product concept with real users before launching the final product.',
    image: 'mvp-development',
    technologies: [
      'discovery',
      'product design',
      'product development',
      'product support & testing',
    ],
    link: 'https://lasoft.org/mvp-development/',
  },
];

const bookingLinkSrc =
  'https://meetings.hubspot.com/solomiia-vuitsyk?uuid=ab878d4d-3be3-4634-8d90-bc1b2ec9e08b';

const LANDING_SECTION_IDS = [
  { name: 'Features', id: 'features' },
  { name: 'How it works', id: 'how-it-works' },
  { name: 'FAQ', id: 'faq' },
];

export {
  ACHIEVEMENTS,
  ANIMATED_COUNTERS,
  bookingLinkSrc,
  FAQ,
  FEATURES_LIST,
  HOW_IT_WORKS,
  IMG,
  KEY_FEATURES,
  LANDING_SECTION_IDS,
  MENU_BUTTONS,
  PHONE_NUMBERS,
  REPORT_OPTIONS,
  REPORT_SERVICES,
  STAGES,
  SUPPORT,
  SUPPORT_LIST_FIELDS,
  TESTIMONIALS,
};
